<template>
  <div
      :class="{'justify-end': $i18n.locale === 'ar'}"
      autocomplete="one-time-code"
      class="flex gap-2"
      style="direction: ltr"
      @paste.prevent="e => handleInput({ target: { value: e.clipboardData.getData('Text') } }, 0)"
  >
    <input
        v-for="(val, i) in values"
        :key="i"
        ref="inputs"
        v-model="values[i]"
        :autocomplete="i === 0 ? 'one-time-code' : 'off'"
        :class="!!error ? 'border-discount-color' : 'border-gray-300'"
        :disabled="loading"
        class="w-12 h-12 text-center rounded text-xl outline-none transition focus:border-brand-blue border"
        inputmode="numeric"
        maxlength="1"
        pattern="\d*"
        style="direction: ltr; text-align: center"
        type="text"
        @input="e => handleInput(e, i)"
        @keydown="e => handleBackspace(e, i)"
    />
  </div>
  <div v-if="error" class="text-discount-color my-3 text-sm">{{ error }}</div>
</template>

<script setup>
const props = defineProps({
  length: {
    type: Number,
    default: 4
  },
  error: {
    type: String,
    default: ''
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['submit']);

const model = defineModel();

const inputs = ref([]);
const values = ref(Array(props.length).fill(''));

const submitted = ref(false);
watch(() => model.value, (val) => {
  if (val.length === props.length) {
    values.value = val.split('');
  } else if (val === '') {
    values.value = Array(props.length).fill('');
    submitted.value = false;
  }
});

watch(values, (val) => {
  const code = val.join('');
  model.value = code;

  if (code.length === props.length && !val.includes('')) {
    if (!submitted.value) {
      submitted.value = true;
      emit('submit', code);
    }
  } else {
    submitted.value = false;
  }
}, {deep: true});

const focusInput = (index = 0) => {
  if (inputs.value.length <= 0) return
  nextTick(() => {
    inputs.value[index]?.focus();
  });
};

const handleInput = (e, i) => {
  const val = e.target.value.replace(/\D/g, '');
  if (!val) return;

  values.value[i] = val[0];
  model.value = values.value.join('')

  if (val.length > 1) {
    const chars = val.split('');
    for (let j = i; j < props.length && chars.length; j++) {
      values.value[j] = chars.shift();
    }
    model.value = values.value.join('')
    focusInput(i + val.length >= props.length ? props.length - 1 : i + val.length);
  } else {
    if (i < props.length - 1) focusInput(i + 1);
  }
};

const handleBackspace = (e, i) => {
  if (e.key === 'Backspace' && !values.value[i] && i > 0) {
    values.value[i - 1] = '';
    model.value = values.value.join('')
    focusInput(i - 1);
  }
};

onMounted(() => {
  focusInput()
});

defineExpose({
  focusInput
})
</script>